module.exports = __webpack_public_path__ + "static/media/ae.a1195174.svg";